import { forwardRef } from 'react'
import { cva } from 'class-variance-authority'
import cn from 'clsx'
import { PauseIcon, PlayIcon } from '../icons'
import type { TPlaybackButtonProps } from './PlaybackButton.types'
import { VisuallyHidden } from '../visually-hidden'
import styles from './PlaybackButton.module.css'

const playbackButton = cva(styles.button, {
    variants: {
        variant: {
            default: styles['variant-default'],
            colorful: styles['variant-colorful'],
            plain: styles['variant-plain'],
        },
        size: {
            small: styles['size-small'],
            medium: styles['size-medium'],
            large: styles['size-large'],
        },
    },
    defaultVariants: { variant: 'default', size: 'medium' },
})

export const PlaybackButton = forwardRef<HTMLButtonElement, TPlaybackButtonProps>(
    (
        {
            className,
            variant = 'default',
            size = 'medium',
            playing = false,
            testID = 'playback-button',
            labelAs = 'text',
            ...props
        },
        ref,
    ) => {
        const Icon = playing ? PauseIcon : PlayIcon
        const label = playing ? 'Pause' : 'Play'

        return (
            <button
                ref={ref}
                type="button"
                data-test={testID}
                aria-label={labelAs === 'aria' ? label : undefined}
                className={cn(playbackButton({ variant, size }), className)}
                {...props}
            >
                <Icon className={styles.icon} />
                {labelAs === 'text' ? <VisuallyHidden>{label}</VisuallyHidden> : null}
            </button>
        )
    },
)
